"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = makeExpiration;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

function makeExpiration(milliseconds) {
  var lastCheck = 0;
  (0, _invariant.default)(typeof milliseconds === 'number', 'makeExpiration: milliseconds must be a number, but got type "%s"', (0, _typeof2.default)(milliseconds));
  return function isExpired() {
    var now = Date.now();
    var expired = now - lastCheck > milliseconds;
    lastCheck = now;
    return expired;
  };
}

module.exports = exports.default;